import { Emojis, LocationCls, ValueCls } from 'app/constants';
import { useAppSelector } from 'app/hooks';
import { getSelectedTeamID, getSelectedWeek, getSelectedYear } from 'app/slices/GamesSlice';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/Routes';

export const TeamIndexRoute: React.FC = () => {
  const navigate = useNavigate();
  const selectedWeek = useAppSelector(getSelectedWeek);
  const selectedYear = useAppSelector(getSelectedYear);
  const selectedTeamId = useAppSelector(getSelectedTeamID);

  useEffect(() => {
    if (selectedWeek.startsWith('Week') && isFinite(parseInt(selectedTeamId)) && isFinite(parseInt(selectedYear))) {
      const values = `year %c ${selectedYear} %c week %c ${selectedWeek} %c teamId %c ${selectedTeamId} %c`;
      const msg = `${Emojis.eyes} %c TeamIndexRoute %c ${values}`;
      console.log(msg, LocationCls, '', ValueCls, '', ValueCls, '', ValueCls, '', ValueCls, '');
      navigate(`${AppRoutes.Team}/${selectedYear}/${selectedWeek.toLowerCase()}/${selectedTeamId}`);
    }
  }, [selectedYear, selectedWeek, selectedTeamId, navigate]);

  return <></>;
};

export default TeamIndexRoute;
